var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadInterfaceBronze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 489.8 489.8",
    style: {
      enableBackground: "new 0 0 489.8 489.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#DE996F;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "489.8,359.8 444.7,359.8 444.7,431.9 45.1,431.9 45.1,361.3 0,361.3 0,477 489.8,477  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "131.7,174.5 69.1,174.5 249.6,398.9 430.2,174.5 367.6,174.5 367.6,12.8 131.7,12.8  "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadInterfaceBronze);
export default __webpack_public_path__ + "static/media/download-interface-bronze.d3522799a3717f65fb3a64acde59000b.svg";
export { ForwardRef as ReactComponent };